/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Complete room information
 * @export
 * @interface RoomDetail
 */
export interface RoomDetail {
    /**
     * Unique room ID
     * @type {number}
     * @memberof RoomDetail
     */
    id: number;
    /**
     * ID of the parent estimate
     * @type {number}
     * @memberof RoomDetail
     */
    estimateId: number;
    /**
     * Room name (e.g., "Kitchen", "Living Room")
     * @type {string}
     * @memberof RoomDetail
     */
    name: string;
    /**
     * Building level (e.g., "1st Floor", "Basement")
     * @type {string}
     * @memberof RoomDetail
     */
    level?: string | null;
    /**
     * When the room was created
     * @type {Date}
     * @memberof RoomDetail
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the RoomDetail interface.
 */
export function instanceOfRoomDetail(value: object): value is RoomDetail {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('estimateId' in value) || value['estimateId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function RoomDetailFromJSON(json: any): RoomDetail {
    return RoomDetailFromJSONTyped(json, false);
}

export function RoomDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'estimateId': json['estimateId'],
        'name': json['name'],
        'level': json['level'] == null ? undefined : json['level'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function RoomDetailToJSON(json: any): RoomDetail {
    return RoomDetailToJSONTyped(json, false);
}

export function RoomDetailToJSONTyped(value?: RoomDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'estimateId': value['estimateId'],
        'name': value['name'],
        'level': value['level'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

